import Select from "react-select";
import React, {useState} from "react";

export default function Comment(){
    const [howFind , setHowFind]=useState([{ value :'Google' , label : 'Google'}]);
    const [selectedFind , setSelectedFind]=useState(null);
    return (
        <div>
            <div className="row mb-4">
                <div className="col-12">
                    <select value={selectedFind} onChange={(e)=>setSelectedFind(e.target.value)} className="form-control form-control-lg">
                        <option disabled selected value> -- Spécifiez Comment -- </option>
                        {howFind.map(option=><option value={option.value} key={option.value}>{option.label}</option>)}
                    </select>
                </div>
            </div>
            <div className="row mb-2 pl-5">
                <div className="form-group">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                        />
                        <label className="form-check-label">
                            Inscrire dans le mail-List
                        </label>
                    </div>
                </div>
            </div>
        </div>
    )
}
